import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './Select.module.css'
import styleNames from '../../utils/styleNames'

export default class Select extends Component {
  static propTypes = {
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    number: PropTypes.number,
    onClick: PropTypes.func,
    styleType: PropTypes.string,
    type: PropTypes.string
  }
  static defaultProps = {
    type: 'checkbox'
  }

  _dummy () {}

  render () {
    const styleType = this.props.styleType ? this.props.styleType : this.props.type
    return (
      <div onClick={this.props.onClick}
        className={styleNames(styles, `select select--${styleType} ${this.props.checked ? 'checked' : ''}`)}>
        <input
          checked={this.props.checked}
          disabled={this.props.disabled}
          onChange={this._dummy}
          type={this.props.type} />
          {this.props.number ?
            <span>{this.props.number}</span>
          : null}
        <div className={styleNames(styles, `select-indicator--${styleType}`)} />
      </div>
    )
  }
}
